import {
  createPromiseAction,
  rejectPromiseAction,
  resolvePromiseAction,
} from 'redux-saga-promise-actions'
import { call, put, takeEvery } from 'redux-saga/effects'
import { authAPI } from '../../api'
import {
  AUTH_FORGOT_PASSWORD_FAILED,
  AUTH_FORGOT_PASSWORD_REQUEST,
  AUTH_FORGOT_PASSWORD_SUCCESS,
} from './actionTypes'

export const authForgotPasswordPA = createPromiseAction(
  AUTH_FORGOT_PASSWORD_REQUEST,
  AUTH_FORGOT_PASSWORD_SUCCESS,
  AUTH_FORGOT_PASSWORD_FAILED
)()

function* forgot(action) {
  try {
    const response = yield call(authAPI.forgotPassword, action.payload)
    const { data } = response

    yield put(authForgotPasswordPA.success({ ...data }))
    resolvePromiseAction(action, { ...data })
  } catch (error) {
    if (!error.response) {
      throw error
    }
    rejectPromiseAction(action, error.response.data)
  }
}

export function* forgotPasswordSaga() {
  yield takeEvery(authForgotPasswordPA.request, forgot)
}
